import React from 'react';
import { LinkButton } from '../LinkButton';
import PropTypes from 'prop-types';

export class Spinning extends React.Component{
    render(){
        let link = <div></div>;
        if (!this.props.playing && !this.props.idling) {
            link = <LinkButton to="/result" class="btn-green" text="Tulossivu" />
        }

        return(
            <div className="col-sm-4 content">
                <article>
                            <h2>Milloin viimeksi elit koko sydämellä?</h2>
                            <p>
                            Anna mennä vain: tutki maailmaa, venytä rajojasi, heittäydy vauhdin vietäväksi – pyöräytä elämänpyörää ja voit löytää itsesi leffateatterista!
                            </p>
                            <ul className="resultList">
                                <li><img src="./assets/lamp.608164f976a5cff5e39ce024ca29fa8f.png" /> Pieni piristys</li>
                                <li><img src="./assets/retry.e8906b0e920914dca95615c116ba1580.png" /> Uusi pyöräytys</li>
                                <li><img src="./assets/thumb.5dc3c33b7feebf48db5f8e690000109e.png" /> Kaikki kunnossa</li>
                            </ul>
                            {link}
                </article>
            </div>
        );
    }
}

Spinning.propTypes = {
    playing: PropTypes.bool.isRequired,
};


// WEBPACK FOOTER //
// ./src/app/components/views/Spinning.js